module.exports = __webpack_public_path__ + "static/media/no-access.5ed8a7f9.svg";